import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { UploadProvider } from '../../contexts/UploadContext';

export const DashboardLayout: React.FC = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

    const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
    const closeMobileMenu = () => setIsMobileMenuOpen(false);

    return (
        <UploadProvider>
            <div className="flex h-screen bg-v3-bg overflow-hidden relative">
                {/* Mobile Overlay */}
                {isMobileMenuOpen && (
                    <div
                        className="fixed inset-0 bg-black/50 z-40 md:hidden animate-fade-in"
                        onClick={closeMobileMenu}
                    />
                )}

                <Sidebar isOpen={isMobileMenuOpen} onClose={closeMobileMenu} />

                <div className="flex-1 flex flex-col min-w-0">
                    <Header onMenuClick={toggleMobileMenu} />

                    <main className="flex-1 overflow-y-auto p-4 md:p-8 custom-scrollbar relative">
                        <div className="max-w-7xl mx-auto">
                            <Outlet />
                        </div>
                    </main>
                </div>
            </div>
        </UploadProvider>
    );
};
